import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { MatchPlayLeaderboardQuery } from '@components/match-play-leaderboard'
import Container from '@material-ui/core/Container'
import RichText from '@components/renderers/render-rich-text'
import defaults from '@config/defaults'
import ErrorBoundary from '@components/error/boundary'
import { NextSeo } from 'next-seo'
import { useSendImpressionEvent } from '@lib/gtm-utils'

const MatchPlayLeaderboardPage = (props) => {
  const {
    headline,
    logo,
    feedId,
    tournamentId,
    heroImage,
    metaDescription,
    description,
    slug,
    tourName,
    trackingEventObject,
  } = props

  useSendImpressionEvent({ event: trackingEventObject?.event, attributes: trackingEventObject?.attributes })

  return (
    <article style={{ background: '#fff' }}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={`Leaderboard - ${tourName} - ${headline}`}
        description={metaDescription || description}
        canonical={`${defaults.baseUrl}events/${slug}/leaderboard`}
        openGraph={{
          title: headline,
          type: 'article',
          url: `${defaults.baseUrl}events/${slug}/leaderboard`,
          images: [{ url: (logo && logo.url) || (heroImage && heroImage.url) }],
        }}
      />

      {tournamentId && feedId ? (
        <MatchPlayLeaderboardQuery
          id={tournamentId}
          {...props}
        />
      ) : (
        <ErrorBoundary>
          <Container>
            <Box my={6}>
              <RichText {...description} />
            </Box>
          </Container>
        </ErrorBoundary>
      )}

    </article>
  )
}

MatchPlayLeaderboardPage.propTypes = {
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  headline: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  location: PropTypes.string,
  logo: PropTypes.shape({ url: PropTypes.string }),
  feedId: PropTypes.string,
  tournamentId: PropTypes.string,
  metaDescription: PropTypes.string,
  description: PropTypes.object,
  tourName: PropTypes.string,
  slug: PropTypes.string,
  nativeAdTitle: PropTypes.string,
  nativeAdDescription: PropTypes.string,
  nativeAdCta: PropTypes.string,
  nativeAdActive: PropTypes.bool,
  showExternalAd: PropTypes.bool,
  fullCoverageUrl: PropTypes.string,
  fullLeaderboard: PropTypes.bool,
  trackingEventObject: PropTypes.object,
}

export default MatchPlayLeaderboardPage
